import React from 'react';
import {Button,Modal,ModalBody,ModalFooter,ModalHeader,Spinner} from 'reactstrap';

// Asked when an answer comes from a maker that has already answered this batch.
// That is normal when two of its models are being compared, and it is also how
// DeepSeek shows up, since it names itself wrong -- "GPT-5.1", a Claude, a
// Gemini. So the name it gave comes first and DeepSeek is the other choice. The
// server has saved nothing yet; see domain/identity.js. Kept in this module:
// modules share no code.
export default function IdentityQuestion({question,busy,onAnswer}){
 const close=()=>onAnswer(null);
 return <Modal isOpen={!!question} toggle={close} centered>
  <ModalHeader toggle={close}>Which model wrote this?</ModalHeader>
  <ModalBody className="fs-14">
   <p>This answer says it is <strong>{question?.claimed}</strong>, but <strong>{question?.alreadyRecorded}</strong>, also from {question?.maker}, has already answered this batch.</p>
   <p>If you ran both, save it under its own name. DeepSeek often gives another model's name: if this is the DeepSeek answer, it will be filed as <strong>{question?.suggest?.name}</strong>, the name of your last DeepSeek answer.</p>
   <p className="text-muted mb-0">Nothing has been saved yet.</p>
  </ModalBody>
  <ModalFooter>
   <Button color="light" disabled={busy} onClick={()=>onAnswer('deepseek')}>It is DeepSeek: save as {question?.suggest?.name}</Button>
   <Button color="primary" disabled={busy} onClick={()=>onAnswer('as-is')}>{busy&&<Spinner size="sm" className="me-1"/>}Save as {question?.filedAs}</Button>
  </ModalFooter>
 </Modal>;
}
